import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Building2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../stores/auth";
import { SectionTitle, type Company } from "../components/admin/shared";
import { CompaniesTable, CreateCompanyForm } from "../components/admin/companies";
import { useSetActiveCompany } from "../components/admin/use-set-active-company";

export const Route = createFileRoute("/admin/companies")({
  component: AdminCompaniesPage,
});

function AdminCompaniesPage() {
  const user = useAuth((s) => s.user);
  const setActiveCompany = useSetActiveCompany();
  const companiesQ = useQuery({
    queryKey: ["admin", "companies"],
    enabled: user?.role === "global_admin",
    queryFn: () => api<{ companies: Company[] }>("/admin/companies"),
  });
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return (
    <section className="space-y-4">
      <SectionTitle icon={<Building2 size={18} />} title="Companies" />
      <CreateCompanyForm />
      <CompaniesTable companies={companiesQ.data?.companies ?? []} onOpen={setActiveCompany} />
    </section>
  );
}
